import { Container, Grid } from "@mui/material";
import InfoForPatient from "./InfoForPatient";
import InfoForSpecialist from "./InfoForSpecialist";

const MoreInfo = () => {
  return (
    <Container disableGutters>
      <Grid container>
        <Grid item xs={12} md={6} lg={6}>
          <InfoForPatient />
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <InfoForSpecialist />
        </Grid>
      </Grid>
    </Container>
  );
};

export default MoreInfo;
